import { ITranslations } from 'types/common';
import { BrandsCatalogueFormTransFields } from './types';
import en from 'translations/en/brandsCatalogueForm.json';
import pl from 'translations/pl/brandsCatalogueForm.json';
import sl from 'translations/sl/brandsCatalogueForm.json';

export const brandsCatalogueFormTranslations: ITranslations<BrandsCatalogueFormTransFields> = {
  name: 'brandsCatalogueForm',
  en,
  pl,
  sl,
};
